export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十大电影推荐',
    excerpt: '从科幻巨制到文艺佳作，我们精选了2024年最值得观看的十部电影，涵盖多种类型与风格...',
    category: '电影资讯',
    date: '2024-06-28',
    views: '12.5万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20movie%20theater%20interior%20with%20rows%20of%20red%20velvet%20seats%2C%20large%20cinema%20screen%20glowing%20with%20warm%20light%2C%20elegant%20architectural%20design%20with%20golden%20accents%2C%20atmospheric%20entertainment%20venue%20photography%20with%20rich%20warm%20tones&width=800&height=500&seq=article-1&orientation=landscape',
    slug: 'top-10-movies-2024',
    content: '随着2024年电影市场的全面复苏，各大制片厂纷纷推出重磅作品。从诺兰导演的新科幻巨制到国产动画电影的新高度，今年注定是影迷的狂欢之年。',
  },
  {
    id: 2,
    title: '国产剧崛起：从网剧到精品化的蜕变之路',
    excerpt: '近年来，国产电视剧经历了从粗制滥造到精品化的巨大转变。本篇文章深入分析这一蜕变背后的原因...',
    category: '剧集解析',
    date: '2024-06-25',
    views: '8.3万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20television%20studio%20set%20with%20multiple%20cameras%20and%20lighting%20equipment%2C%20director%20monitoring%20screens%20showing%20drama%20scenes%2C%20behind%20the%20scenes%20production%20atmosphere%2C%20warm%20indoor%20lighting%20with%20professional%20equipment%20arrangement&width=800&height=500&seq=article-2&orientation=landscape',
    slug: 'domestic-drama-rise',
    content: '国产电视剧正在经历前所未有的精品化浪潮。从《长安十二时辰》到《三体》，每一部作品都代表着行业的新高度。',
  },
  {
    id: 3,
    title: 'Netflix最佳纪录片榜单：探索真实世界的窗口',
    excerpt: '纪录片是了解世界的最佳窗口。我们整理了Netflix平台上评分最高的纪录片，涵盖自然、历史、科技等多个领域...',
    category: '纪录片',
    date: '2024-06-22',
    views: '15.2万',
    image: 'https://readdy.ai/api/search-image?query=Professional%20documentary%20filmmaking%20scene%20with%20camera%20crew%20in%20exotic%20location%2C%20wildlife%20photographer%20with%20telephoto%20lens%20in%20natural%20habitat%2C%20warm%20golden%20hour%20lighting%2C%20nature%20documentary%20production%20atmosphere%20with%20professional%20equipment&width=800&height=500&seq=article-3&orientation=landscape',
    slug: 'netflix-documentaries',
    content: 'Netflix的纪录片库堪称世界之最，从《我们的星球》到《美国工厂》，每一部都引发全球热议。',
  },
  {
    id: 4,
    title: '动漫产业报告：中国动画电影票房破百亿背后的故事',
    excerpt: '中国动画电影市场在2024年实现了历史性突破，全年票房突破百亿大关。本文深度解析这一现象级增长...',
    category: '产业观察',
    date: '2024-06-20',
    views: '6.7万',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animation%20studio%20workspace%20with%20multiple%20monitors%20showing%20character%20designs%20and%20storyboards%2C%20artists%20drawing%20tablets%20and%20concept%20art%20on%20walls%2C%20creative%20atmosphere%20with%20warm%20natural%20lighting%2C%20modern%20digital%20art%20production%20environment&width=800&height=500&seq=article-4&orientation=landscape',
    slug: 'china-animation-report',
    content: '从《大圣归来》到《哪吒之魔童降世》，中国动画电影正在创造属于自己的黄金时代。',
  },
  {
    id: 5,
    title: '音乐节现场拍摄指南：如何记录完美的演出瞬间',
    excerpt: '音乐节现场拍摄是一门独特的艺术。本文分享专业摄影师的拍摄技巧，帮助你捕捉最精彩的演出瞬间...',
    category: '拍摄技巧',
    date: '2024-06-18',
    views: '4.1万',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20with%20raised%20hands%20and%20phone%20lights%20at%20night%2C%20colorful%20stage%20lights%20creating%20dramatic%20atmosphere%2C%20concert%20photography%20perspective%20from%20crowd%20level%2C%20warm%20vibrant%20colors%20with%20energy%20and%20excitement&width=800&height=500&seq=article-5&orientation=landscape',
    slug: 'music-festival-shooting',
    content: '音乐节摄影需要在快速变化的灯光和动态的环境中捕捉精彩瞬间，掌握这些技巧让你也能拍出专业级作品。',
  },
  {
    id: 6,
    title: '视频平台发展趋势：AI技术如何改变内容消费',
    excerpt: '人工智能技术正在深刻改变视频内容的创作和消费方式。从智能推荐到AI生成内容，未来已来...',
    category: '行业趋势',
    date: '2024-06-15',
    views: '9.8万',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20interface%20with%20holographic%20video%20screens%20and%20neural%20network%20visualizations%2C%20modern%20control%20room%20with%20glowing%20data%20displays%2C%20warm%20amber%20and%20cool%20blue%20lighting%20contrast%2C%20sci-fi%20tech%20atmosphere%20with%20clean%20minimalist%20design&width=800&height=500&seq=article-6&orientation=landscape',
    slug: 'ai-video-trends',
    content: 'AI技术正在重塑视频行业的方方面面，从内容创作到用户分发，每个环节都在经历深刻变革。',
  },
];

export const articleSlugs = articles.map((a) => a.slug);